import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import { PriorityTypes } from '../Calendar/Events/ActivityEvent';

export function getPriorityIcons(priority: PriorityTypes) {
  switch (priority) {
    case PriorityTypes.Low:
      return (
        <KeyboardDoubleArrowDownIcon
          style={{ color: 'green', fontSize: '18px' }}
        />
      );
    case PriorityTypes.Normal:
      return (
        <RadioButtonUncheckedIcon style={{ color: 'blue', fontSize: '18px' }} />
      );
    case PriorityTypes.High:
      return (
        <KeyboardDoubleArrowUpIcon style={{ color: 'red', fontSize: '18px' }} />
      );
    default:
      return null;
  }
}
